import { Dispatch, ReactNode, SetStateAction } from 'react';
import { CorporatePartner } from '../../../../../../interfaces/CorporatePartner';
import {
    BillOfLaden,
    BillOfLadenFormErrors
} from '../../../../../../interfaces/BillOfLaden';
import { TransformedItems } from '../../../../../../pages/dashboard/tradedocuments/tradeDocumentTypes/CommercialTypes';
import FormFooter from '../../../common/FormFooter';
import StepOne from './StepOne';
import StepTwo from './StepTwo';

interface BillOfLadenMobileFormProps {
    updateField: (name: string, value: string | number) => void;
    payload: BillOfLaden;
    corporatePartners: CorporatePartner[];
    loadingCorporatepartners: boolean;
    setShowAddPartner: Dispatch<SetStateAction<boolean>>;
    errors: BillOfLadenFormErrors;
    quoteFields: TransformedItems[];
    updateQuoteField: (
        index: number,
        attributeName: keyof TransformedItems,
        attributeValue: TransformedItems[keyof TransformedItems]
    ) => void;
    removeQuoteField: (index: number) => void;
    totalAmount: number;
    addQuoteField: () => void;
    setSignatureUrlBase64: (value: string) => void;
    signatureUrlBase64: string;
    activeStep: number;
    setActiveStep: (step: number) => void;
    onSaveOnlyAction?: () => void;
    showPreview: boolean;
    setShowPreview: (val: boolean) => void;
}

const BillOfLadenMobileForm = ({
    updateField,
    payload,
    corporatePartners,
    loadingCorporatepartners,
    setShowAddPartner,
    errors,
    quoteFields,
    updateQuoteField,
    removeQuoteField,
    addQuoteField,
    setSignatureUrlBase64,
    signatureUrlBase64,
    totalAmount,
    activeStep,
    setActiveStep,
    showPreview,
    setShowPreview,
    onSaveOnlyAction
}: BillOfLadenMobileFormProps) => {
    const views: {
        [key: number]: ReactNode;
    } = {
        0: (
            <StepOne
                {...{
                    updateField,
                    payload,
                    corporatePartners,
                    loadingCorporatepartners,
                    setShowAddPartner,
                    errors,
                    quoteFields,
                    updateQuoteField,
                    removeQuoteField,
                    addQuoteField,
                    activeStep,
                    setActiveStep
                }}
            />
        ),
        1: (
            <StepTwo
                {...{
                    updateField,
                    payload,
                    errors,
                    setSignatureUrlBase64,
                    signatureUrlBase64
                }}
            />
        )
    };

    return (
        <div className='lg:hidden pt-4'>
            {views[activeStep]}
            <FormFooter
                onContinue={() => {
                    setActiveStep(activeStep + 1);
                }}
                onSave={() => onSaveOnlyAction && onSaveOnlyAction()}
                onPreview={() => setShowPreview(!showPreview)}
                onGoBack={() => {
                    setActiveStep(activeStep - 1);
                }}
                steps={2}
                activeStep={activeStep}
                disabled={Object.values(payload).some(
                    (item) => item === undefined
                )}
            />
        </div>
    );
};

export default BillOfLadenMobileForm;
